import { createContext, useContext, useEffect, useState } from "react";
import localization from "./index";
import { localStorageService } from "../../services";
import { SupportedLanguages } from "../../models/constants/supportedLanguages";

type LanguageContextType = {
  language: string;
  setLanguage: (lang: string) => void;
};

const LanguageContext = createContext<LanguageContextType | null>(null);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguageState] = useState(
    localStorageService.getItem<string>("languageCode") || SupportedLanguages.English
  );

  const setLanguage = (lang: string) => {
    localization.setLanguage(lang);
    setLanguageState(lang);
    localStorageService.setItem("languageCode", lang);
  };

  useEffect(() => {
    localization.setLanguage(language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used inside LanguageProvider");
  }
  return context;
}
